import axios from "axios";

const urls = process.env.REACT_APP_BASE_URL;

//메인 배너 리스트
export const requestBannerList = (params) =>
  axios
    .post(`${urls}/public/banner/list`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//제휴 아이콘 리스트
export const requestAffiliateIconList = (params) =>
  axios
    .post(`${urls}/public/affiliate/icon/list`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));

//제휴사 소개 페이지
export const requestAffiliateList = (params) =>
  axios
    .post(`${urls}/public/affiliate/list`, params)
    .then((response) => ({ response }))
    .catch((err) => ({ err }));
